import { GitPullRequest } from 'lucide-react';
import { css } from 'styled-system/css';
import { FakeBtn } from './FakeBtn';

export function ReviewOverlay() {
  return (
    <div
      className={css({
        position: 'absolute',
        inset: '3',
        left: 'auto',
        zIndex: 2,
        width: { base: '58%', md: '46%' },
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'none',
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '3',
          flex: 1,
          minHeight: 0,
          padding: '4',
          background: 'bg.surface',
          border: '1px solid token(colors.border.hairline)',
          borderRadius: '12px',
          overflow: 'hidden',
        })}
      >
        <span>Proposal</span>
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: '2',
            fontFamily: 'mono',
            fontSize: '2xs',
            color: 'signal.valid',
          })}
        >
          <GitPullRequest size={12} strokeWidth={2} />
          Open
        </div>
        <p
          className={css({
            margin: 0,
            fontFamily: 'display',
            fontWeight: 'bold',
            fontSize: 'sm',
            color: 'text.primary',
          })}
        >
          Update lagging prices
        </p>
        <p
          className={css({
            margin: 0,
            fontSize: 'xs',
            color: 'text.secondary',
            lineHeight: 'snug',
          })}
        >
          CVX 23.90 → 24.20
          <br />
          META 28.20 → 26.80
        </p>
        <div
          className={css({
            display: 'flex',
            gap: '2',
            marginTop: '2',
          })}
        >
          <FakeBtn>Reject</FakeBtn>
          <FakeBtn primary>Approve</FakeBtn>
        </div>
      </div>
    </div>
  );
}
